<template>
  <div class="w-full">
    <vx-card :title="titleCard" class="mb-base">
      <div class="flex">

        <div class="vx-col w-full md:w-1/2">

          <!-- Compañía -->
          <div>
            <label class="text-sm ">Compañía</label>
            <v-select v-model="company_id" name="company_id" label="id" class="w-1/2 mb-5"
              :options="companiesList" :reduce="item => item.id" :disabled="this.companyDisabled"
              @input="handleCompany" :filter="fuseSearch">
              <template #selected-option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
              <template #option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
            </v-select>
          </div>

          <!-- Proyecto -->
          <div>
            <label class="text-sm ">Proyecto</label>
            <v-select v-model="projectId" name="projectId" label="id" class="w-1/2 mb-5"
              :options="projectList" :reduce="item => item.id"
              @input="handleProject" :filter="fuseSearch">
              <template #selected-option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
              <template #option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
            </v-select>
          </div>

          <!-- Subproyecto -->
          <div>
            <label class="text-sm ">Subproyecto</label>
            <v-select v-model="subProjectId" name="subProjectId" label="id" class="w-1/2 mb-5"
              :options="subProjectList" :reduce="item => item.id" :disabled="this.subProjectDisabled"
              :filter="fuseSearch">
              <template #selected-option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
              <template #option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
            </v-select>
          </div>
          <div>
            <label class="text-sm ">Tipo de cuenta</label>
            <v-select v-model="idAccountType" name="idAccountType" label="id" class="w-1/2 mb-5"
              :options="tiposCuenta" :reduce="item => item.id_account_type"
              :filter="fuseSearch">
              <template #selected-option="{ id_account_type, descripcion }">
                {{ id_account_type }} - {{ descripcion }}
              </template>
              <template #option="{ id_account_type, descripcion }">
                {{ id_account_type }} - {{ descripcion }}
              </template>
            </v-select>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <vs-input v-model="name" label="Nombre del aliado" class="w-1/2 mb-5"/>
          <vs-input v-model="last_name" label="Apellido del aliado" class="w-1/2 mb-5"/>
          <div>
            <label class="text-sm ">Tipo de identificación</label>
            <v-select v-model="id_identification_type" name="id_identification_type" label="id" class="w-1/2 mb-5"
              :options="tiposIdentificacion" :reduce="item => item.ident_type_id"
              :filter="fuseSearch">
              <template #selected-option="{ ident_type_id, descripcion }">
                {{ ident_type_id }} - {{ descripcion }}
              </template>
              <template #option="{ ident_type_id, descripcion }">
                {{ ident_type_id }} - {{ descripcion }}
              </template>
            </v-select>
          </div>
          <vs-input type="number" v-model="identification" label="Identificación/NIT" class="w-1/2 mb-5"/>
          <vs-input v-model="country" label="País" class="w-1/2 mb-5"/>
          <vs-input v-model="state" label="Departamento" class="w-1/2 mb-5"/>
          <vs-input v-model="city" label="Ciudad" class="w-1/2 mb-5"/>
        </div>
      </div>
    </vx-card>
    <div class="vx-col w-full flex" id="account-manage-buttons">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" @click="this.$props.closeSidebar">Cancelar</vs-button>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import VxCard from '../../../components/vx-card/VxCard.vue'
import ListasModule from '@/store/listas-module/moduleDataList.js'
import AliadosModule from '@/store/cuenta-aliada-module/moduleDataList.js'
import { companiesEnums, searchCompany, searchCompanyById } from '../../../config/companies.js'
export default {
  components: { VxCard },
  data () {
    return {
      company: null,
      company_id: '',
      projectId: null,
      subProjectId: null,
      titleCard: '',
      id_account: null,
      idAccountType: '',
      name: '',
      last_name: null,
      id_identification_type: '',
      identification: '',
      country: '',
      state: '',
      city: '',
      subProjectListTmp: [],
      subProjectDisabled: false,
      companyDisabled: false
    }
  },
  props: {
    propModeCreate: {
      type: Boolean,
      default: true
    },
    propData: {
      type: Object,
      default: () => {}
    },
    closeSidebar: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    companiesList () {
      return this.$store.state.ListasModule.companies
    },
    projectList() {
      return this.$store.state.ListasModule.proyecto
    },
    subProjectList() {
      return this.$store.state.ListasModule.sub_proyecto
    },
    tiposIdentificacion () {
      return this.$store.state.ListasModule.tiposIdentificacion
    },
    tiposCuenta () {
      return this.$store.state.ListasModule.tiposCuenta
    }
  },
  created () {
    if (!ListasModule.isRegistered) {
      this.$store.registerModule('ListasModule', ListasModule)
      ListasModule.isRegistered = true
    }

    if (!AliadosModule.isRegistered) {
      this.$store.registerModule('AliadosModule', AliadosModule)
      AliadosModule.isRegistered = true
    }

    this.company = searchCompany(this.$route.params.nameCompany)
    this.company_id = this.company.idCompany
    this.companyDisabled = this.company.nameCompany != companiesEnums.ARQUITECSOFT
    console.log("company: ", this.company, ", companyDisabled: ", this.companyDIsabled)
    this.initListOfValues()

    if (this.$props.propModeCreate === true) {
      this.titleCard = 'Crear cuenta aliada'
    } else {
      this.titleCard = 'Editar cuenta aliada'
      this.id_account = this.$props.propData.idAccount
      this.idAccountType = this.$props.propData.idAccountType
      this.name = this.$props.propData.name
      this.last_name = this.$props.propData.lastName
      this.id_identification_type = this.$props.propData.idIdentificationType
      this.identification = this.$props.propData.identification
      this.country = this.$props.propData.country
      this.state = this.$props.propData.state
      this.city = this.$props.propData.city,
      this.projectId = this.$props.propData.idProject,
      this.subProjectId = this.$props.propData.idSubProject
    }
  },
  methods: {
    actionSaveData () {
      console.log('Guardando datos')
      const data = {
        accountId: this.id_account,
        idAccountType: this.idAccountType,
        name: this.name,
        last_name: this.last_name,
        idIdentificationType: this.id_identification_type,
        nit: this.identification,
        country: this.country,
        state: this.state,
        city: this.city,
        idCompany: this.company_id,
        idProject: this.projectId,
        idSubProject: this.subProjectId,
      }
      console.log("data to send: ", data)

      this.$store
        .dispatch('AliadosModule/insertOrReplaceAllyAccount', data)
        .then((response) => {
          this.$vs.dialog({
            color: 'success',
            title: 'Exito',
            text: 'Se guardó la cuenta aliada correctamente.',
            acceptText: 'Aceptar',
            accept: this.$props.closeSidebar.bind(this)
          })
        })
        .catch((error) => {
          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text:
              'Error. ' + error,
            acceptText: 'Aceptar',
            accept: this.$props.closeSidebar.bind(this)
          })
          console.log(error)
        })
    },
    fuseSearch(options, search) {
      if (!search) return options;

      const fuse = new Fuse(options, {
        keys: ['id', 'descripcion'],
        threshold: 0.3,
        shouldSort: true,
      });

      const results = fuse.search(search).map(result => result.item);

      return results;
    },
    initListOfValues() {
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      //this.casoCompaniaId = searchCompany(this.$route.params.nameCompany).idCompany

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getCompanias', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAccountTypes')
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getIdentificationTypes')
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

      this.getAllProject()
    },
    handleCompany(item) {
      this.company = searchCompanyById(item)
      this.getAllProject()
    },
    getAllProject() {

      // Eliminamos la lista de datos de los Projects
      this.projectId = null
      this.$store.dispatch('ListasModule/clearAllProyecto')

      // Eliminamos la lista de todos los demás datos
      this.clearAllList()

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAllProyecto', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()

          if (response.data) {
            const list = response.data.listaProject
            if (list) {
              if (list.length === 1) {
                const id = list[0].id
                this.projectId = id

                this.handleProject(id)
              }
            }
          }
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    handleProject(item) {
      this.clearAllList()

      if (item) {
        const companyTemp = this.company
        companyTemp.idProject = item
        //console.log('companyTemp', companyTemp)

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllSubProyecto', companyTemp)
          .then((response) => {
            if (response && response.data) {
              this.subProjectListTmp = response.data.listaSubProject
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    clearAllList() {
      this.subProjectListTmp = []
    }
  }
}
</script>

<style>

</style>
